var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.375 41.5L31.943 42.8962L33.375 44.3649L34.807 42.8962L33.375 41.5ZM35.375 2.49999C35.375 1.39542 34.4796 0.499993 33.375 0.499993C32.2704 0.499993 31.375 1.39542 31.375 2.49999L35.375 2.49999ZM10.818 21.2295L31.943 42.8962L34.807 40.1038L13.682 18.4371L10.818 21.2295ZM34.807 42.8962L55.932 21.2295L53.068 18.4371L31.943 40.1038L34.807 42.8962ZM35.375 41.5L35.375 2.49999L31.375 2.49999L31.375 41.5L35.375 41.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 51.25L2.5 55.5833C2.5 60.3698 6.44949 64.25 11.3214 64.25L55.4286 64.25C60.3005 64.25 64.25 60.3698 64.25 55.5833V51.25",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportBig);
export default __webpack_public_path__ + "static/media/importBig.af4e4275e2d50cb8ea0beb5f726ca0cc.svg";
export { ForwardRef as ReactComponent };